import GenericError from 'pages/Authorize/Errors/GenericError';

const StaticLinkDisabled = () => (
  <GenericError title="Link Inactive">
    This link is no longer active. Please reach out to the organization that
    provided it to request a new one.
  </GenericError>
);

export default StaticLinkDisabled;
